<!-- BSG-compliant version with keyboard accessibility -->
<ion-content>
	<!-- Skip link for keyboard users -->

	<div id="main-content">
		<div class="order-types bsg-order-types">
			<div class="padding-block"></div>
			<div class="info_block bsg-info-block">
				<h4 id="order-type-heading">{{'home_page.order_type_title'| translate}}</h4>

				<!-- Order type selection with keyboard navigation -->
				<div class="order-types-blocks bsg-order-types-blocks" role="radiogroup" aria-labelledby="order-type-heading">
					@for (item of preorderTypes; track $index) {
					<div
						(click)="navigateToMap(item)"
						(keydown.enter)="navigateToMap(item)"
						(keydown.space)="navigateToMap(item)"
						[class.selected]="selectedPreorderType == item"
						class="order-type-item bsg-order-type-item"
						role="radio"
						[attr.aria-checked]="selectedPreorderType == item"
						tabindex="0"
					>
						<div class="logo-block">
							<ion-icon
								[src]="'../../../assets/dean_and_david/preorder_type/' + item+ '.svg'"
								[attr.aria-label]="'venue_suggestion.' + item + '.title'| translate"
								role="img"
							></ion-icon>
						</div>

						<div class="text-block">
							<h3>{{'venue_suggestion.' + item + '.title'| translate }}</h3>
							<p>{{'venue_suggestion.' + item + '.subtitle'| translate }}</p>
						</div>
					</div>
					}
				</div>
			</div>
		</div>
	</div>

	<!-- Orders and content cards section -->
	<div class="orders-block" *ngIf="orders.length > 0 || (contentCards$ | async).length > 0">
		<!-- News section -->
		<div class="width-wrapper news-section" *ngIf="(contentCards$ | async) as cards" aria-label="News and updates">
			<ng-container *ngFor="let card of cards; let i = index">
				<app-draw-news-braze-item
					[card]="card"
					[attr.tabindex]="0"
					[attr.aria-posinset]="i + 1"
					[attr.aria-setsize]="cards.length"
				></app-draw-news-braze-item>
			</ng-container>
		</div>

		<!-- Last orders section -->
		<div class="width-wrapper" *ngIf="orders.length > 0">
			<h4 id="last-orders-heading">{{'home_page.last_orders' | translate}}</h4>
			<div class="wrapper-for-orders" role="list" aria-labelledby="last-orders-heading">
				<ng-container *ngFor="let item of orders; let i = index">
					<app-my-order
						[order]="item"
						[showMinInfo]="true"
						[attr.tabindex]="0"
						role="listitem"
						[attr.aria-posinset]="i + 1"
						[attr.aria-setsize]="orders.length"
					></app-my-order>
				</ng-container>
			</div>
		</div>
	</div>
</ion-content>
